<template>
  <div class="flex items-center gap-2">
    <img :src="currentIcon" v-if="hasIcon && currentIcon" />
    <p :class="[textColor, textSize]" class="font-medium capitalize">
      {{ displayText }}
    </p>
  </div>
</template>

<script>
import redEllipse from "../../../../assets/svg/red-ellipse.svg";
import greenEllipse from "../../../../assets/svg/green-ellipse.svg";
import grayEllipse from "../../../../assets/svg/grey-ellipse.svg";
import yellowEllipse from "../../../../assets/svg/yellow-ellipse.svg";
import blueEllipse from "../../../../assets/svg/blue-ellipse.svg";
import blackEllipse from "../../../../assets/svg/black-ellipse.svg";
import { lowerCase } from "@/core/helpers/utility";

export default {
  name: "StatusColumn",
  props: {
    text: {
      type: String,
      required: false,
      default: "",
    },
    textSize: {
      type: String,
      required: false,
      default: "text-sm",
    },
    hasIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    displayText() {
      return this.text === "Pushed_MID" ? "Pushed" : this.text;
    },

    normalizedText() {
      return this.text?.trim().toLowerCase() || "";
    },

    textColor() {
      const text = this.normalizedText;

      if (
        text === "completed" ||
        text === "connected" ||
        text === "all approved" ||
        text === "all accepted" ||
        text === "accepted" ||
        text === "confirmed" ||
        text === "paid" ||
        text === "fulfilled" ||
        text === "active" ||
        text === "true" ||
        text === "successful" ||
        text === "approved" ||
        text === "transaction approved" ||
        text === "approved or completed successfully" ||
        text === "open" ||
        text === "ok" ||
        text === "activated" ||
        text === "start"
      ) {
        return "text-estationsGreen-400";
      } else if (
        text === "offline" ||
        text === "all denied" ||
        text === "declined" ||
        text === "denied" ||
        text === "not fixing" ||
        text === "not fixed" ||
        text === "rejected" ||
        text === "due" ||
        text === "overdue" ||
        text === "deactivated" ||
        text === "expired" ||
        text === "false" ||
        text === "inactive" ||
        text === "closed" ||
        text === "failed" ||
        text === "not activated"
      ) {
        return "text-[#D44333]";
      } else if (
        text === "faulty" ||
        text === "part paid" ||
        text === "in progress"
      ) {
        return "text-[#BC8B2C]";
      } else if (text === "disconnected") {
        return "text-gray-500";
      } else if (text === "online" || text === "processed") {
        return "text-blue-500";
      } else if (
        text === "partially approved" ||
        text === "fixed" ||
        text === "notselling" ||
        text === "staticproductlevel" ||
        text === "pushed_mid"
      ) {
        return "text-blue-500";
      } else if (text === "active") {
        return "text-estationsGreen-700";
      } else if (
        text === "suspended" ||
        text === "partially accepted" ||
        text === "submitted" ||
        text === "renewaldue" ||
        text === "pending"
      ) {
        return "text-[#BC8B2C]";
      } else if (text === "pending approval" || text === "fixing") {
        return "text-[#000]";
      }

      return "text-gray-600";
    },

    currentIcon() {
      const text = this.normalizedText;

      if (
        text === "completed" ||
        text === "connected" ||
        text === "all approved" ||
        text === "all accepted" ||
        text === "accepted" ||
        text === "confirmed" ||
        text === "paid" ||
        text === "fulfilled" ||
        text === "active" ||
        text === "true" ||
        text === "successful" ||
        text === "approved" ||
        text === "transaction approved" ||
        text === "approved or completed successfully" ||
        text === "open" ||
        text === "ok" ||
        text === "activated" ||
        text === "start"
      ) {
        return greenEllipse;
      } else if (
        text === "offline" ||
        text === "all denied" ||
        text === "declined" ||
        text === "denied" ||
        text === "not fixing" ||
        text === "not fixed" ||
        text === "rejected" ||
        text === "due" ||
        text === "overdue" ||
        text === "deactivated" ||
        text === "expired" ||
        text === "false" ||
        text === "inactive" ||
        text === "closed" ||
        text === "failed" ||
        text === "not activated"
      ) {
        return redEllipse;
      } else if (
        text === "faulty" ||
        text === "part paid" ||
        text === "in progress"
      ) {
        return yellowEllipse;
      } else if (text === "disconnected") {
        return grayEllipse;
      } else if (
        text === "online" ||
        text === "notselling" ||
        text === "staticproductlevel" ||
        text === "processed"
      ) {
        return blueEllipse;
      } else if (
        text === "partially approved" ||
        text === "fixed" ||
        text === "pushed_mid"
      ) {
        return blueEllipse;
      } else if (text === "active") {
        return greenEllipse;
      } else if (
        text === "suspended" ||
        text === "partially accepted" ||
        text === "submitted" ||
        text === "renewaldue" ||
        text === "pending"
      ) {
        return yellowEllipse;
      } else if (text === "pending approval" || text === "fixing") {
        return blackEllipse;
      }

      return "";
    },
  },
};
</script>

<style>
/* table columns styling options */
.positive {
  font-weight: 500;
  font-size: 14px;
  color: #155c22;
}

.negative {
  font-weight: 500;
  font-size: 14px;
  color: #e11900;
}
</style>
